package com.trevorwiebe.timesheet.admin.usermanagement.presentation

import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.core.domain.model.UserRole
import kotlinx.datetime.LocalDate

sealed class UserManagementEvent {
    data object OnAddUserClick : UserManagementEvent()
    data class OnEditUserClick(val user: DatabaseUserModel) : UserManagementEvent()
    data object OnDismissDialog : UserManagementEvent()

    data class OnCreateUser(
        val name: String,
        val email: String,
        val payEntryId: String,
        val nickname: String,
        val hireDate: LocalDate,
        val ptoBalance: Int,
        val fullTime: Boolean,
        val holidayTime: Boolean,
        val role: UserRole,
        val ownerOperatorId: String?,
    ) : UserManagementEvent()

    data class OnUpdateUser(
        val name: String,
        val email: String,
        val payEntryId: String,
        val nickname: String,
        val hireDate: LocalDate,
        val ptoBalance: Int,
        val fullTime: Boolean,
        val holidayTime: Boolean,
        val role: UserRole,
        val ownerOperatorId: String?,
    ) : UserManagementEvent()

    data object OnSendPasswordResetEmail : UserManagementEvent()
    data object OnDeleteUser : UserManagementEvent()
    data object OnRestoreUser : UserManagementEvent()
    data class OnShowDeletedToggled(val show: Boolean) : UserManagementEvent()
    data object OnErrorShown : UserManagementEvent()
}
